import { useRef, useState } from 'react'

export const APP_URL = 'https://app.ghostlaundry.com'

// "Copy link" with a real fallback.
//
// navigator.clipboard needs a secure context AND permission, and several
// in-app browsers — the exact place this button matters most — refuse it.
// When it throws we select the text in a hidden input and run the legacy
// execCommand, which still works there. A button that silently does nothing
// is worse than no button.
export default function CopyLinkButton({ className = '', label = 'Copy link' }) {
  const [copied, setCopied] = useState(false)
  const inputRef = useRef(null)

  async function copy() {
    let ok = false
    try {
      await navigator.clipboard.writeText(APP_URL)
      ok = true
    } catch {
      try {
        const el = inputRef.current
        el.focus()
        el.setSelectionRange(0, APP_URL.length)
        ok = document.execCommand('copy')
      } catch { ok = false }
    }
    if (ok) {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } else {
      // Nothing worked — leave the URL selected so they can copy by hand.
      inputRef.current?.focus()
      inputRef.current?.setSelectionRange(0, APP_URL.length)
    }
  }

  return (
    <>
      <button
        type="button"
        onClick={copy}
        className={className || 'rounded-lg bg-navy px-4 py-2 text-[12px] font-extrabold text-white'}
      >
        {copied ? '✓ Link copied' : label}
      </button>
      {/* Off-screen rather than display:none — a hidden input cannot be
          selected, and selection is what the fallback relies on. */}
      <input
        ref={inputRef}
        readOnly
        value={APP_URL}
        aria-hidden="true"
        tabIndex={-1}
        className="pointer-events-none absolute left-[-9999px] h-px w-px opacity-0"
      />
    </>
  )
}
